import { useMutation } from '@tanstack/react-query';
import { exitPreview, isNotSignedIn } from '../api';
import { useToast } from '../ui';
import { leaveTo } from './leave';
import { SIGNED_OUT_PATH } from './useSignOut';

/**
 * "Exit preview" in the banner: `DELETE /api/v1/me/preview`, then a full page load of Home, so
 * nothing fetched while previewing (sample data, empty live lists) stays on screen. The server
 * never refuses an exit, even after Preview access has ended.
 */
export function useExitPreview(): () => void {
  const toast = useToast();
  const mutation = useMutation({
    mutationFn: exitPreview,
    meta: { handlesNotSignedIn: true },
    onSuccess: () => {
      leaveTo('/');
    },
    onError: (error) => {
      if (isNotSignedIn(error)) {
        leaveTo(SIGNED_OUT_PATH);
        return;
      }
      toast.show({
        tone: 'problem',
        title: 'You’re still previewing',
        body: 'We couldn’t reach MyRewards to end the preview. Try again in a moment.',
      });
    },
  });
  return () => {
    if (!mutation.isPending) mutation.mutate();
  };
}
